import * as React from "react";
import { TextFieldProps, TextField } from "@mui/material";
import useIsOverflowing from "../core/useIsOverflowing";
import { GroupedNavigationContext } from "./GroupedNavigationContext";
import Tooltip from "./Tooltip";

const TextFieldWithOverflowLabel: React.FC<
  TextFieldProps & { label?: string }
> = (props) => {
  const {
    FormHelperTextProps,
    InputLabelProps,
    inputProps,
    label,
    tabIndex,
    ...otherProps
  } = props;
  const { isOverflowing, ref } = useIsOverflowing<HTMLLabelElement>();
  const { groupControlsFocus } = React.useContext(GroupedNavigationContext);

  // Prevent hover/touch on helper text from making overflow tooltip appear
  const helperTextProps: typeof FormHelperTextProps = React.useMemo(
    () => ({
      ...FormHelperTextProps,
      onMouseOver: (event) => {
        FormHelperTextProps?.onMouseOver?.(event);
        event.stopPropagation();
      },
      onTouchStart: (event) => {
        FormHelperTextProps?.onTouchStart?.(event);
        event.stopPropagation();
      },
    }),
    [FormHelperTextProps]
  );

  return (
    <Tooltip isOverflowing={isOverflowing} placement="top" title={label}>
      <TextField
        FormHelperTextProps={helperTextProps}
        inputProps={{
          ...inputProps,
          tabIndex: groupControlsFocus ? -1 : tabIndex,
        }}
        InputLabelProps={{ ref, ...InputLabelProps }}
        label={label}
        {...otherProps}
      />
    </Tooltip>
  );
};

export default TextFieldWithOverflowLabel;
